import { HTTP } from "@/api/http-common";
import ENDPOINT from "@/api/endpoints";

export function callApiLayDanhSachTatCaQuyen(payload, endpoint) {
  return new Promise((resolve, reject) => {
    return HTTP.post(endpoint, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachQuyenTheoAppPaging(payload) {
  return HTTP({
      url: ENDPOINT.PERMISSION.DANH_SACH_QUYEN_THEO_APP,
      method: "POST",
      data: payload
  });
}

export function callApiLayDanhSachTatCaQuyenTheoApp(payload) {
  return HTTP({
      url: ENDPOINT.PERMISSION.DANH_SACH_TAT_CA_QUYEN_THEO_APP,
      method: "GET",
      params: payload
  });
}

export function callApiLayDanhSachQuyenKhongThuocVaiTro(payload) {
  return HTTP({
      url: ENDPOINT.PERMISSION.DANH_SACH_QUYEN_KHONG_THUOC_VAI_TRO,
      method: "GET",
      params: payload
  });
}

export function callApiLayDanhSachQuyenTheoVaiTro(payload) {
  return HTTP({
      url: ENDPOINT.PERMISSION.DANH_SACH_QUYEN_THEO_VAI_TRO,
      method: "GET",
      params: payload
  });
}

export function callApiLayDanhSachQuyenKhongThuocGroup(payload) {
  return HTTP({
      url: ENDPOINT.PERMISSION.DANH_SACH_QUYEN_KHONG_THUOC_GROUP,
      method: "GET",
      params: payload
  });
}

export function callApiAddOrUpdateObjectPermisions(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.PERMISSION.ADD_OR_UPDATE_OBJECT_PERMISSION, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiRemoveItemObjectPermission(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.PERMISSION.REMOVE_ITEM_OBJECT_PERMISSION, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiActivePermission(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.PERMISSION.ACTIVE_PERMISSION, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiXoaPhamViQuyen(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.PERMISSION.XOA_PHAM_VI_QUYEN, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiConfigPhamViQuyen(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.PERMISSION.CONFIG_PHAM_VI_QUYEN, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiXoaActorMapping(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.PERMISSION.XOA_ACTOR_MAPPING, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}